/**
 * @generated SignedSource<<7d7c28cecbb10cd18945d92b92708d63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationTomraScreenMutation$variables = {
  teamIds: ReadonlyArray<string>;
};
export type IntegrationTomraScreenMutation$data = {
  readonly store: {
    readonly setTomraTeamIds: {
      readonly id: string;
      readonly teamIds: ReadonlyArray<string> | null;
    } | null;
  };
};
export type IntegrationTomraScreenMutation = {
  response: IntegrationTomraScreenMutation$data;
  variables: IntegrationTomraScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "teamIds",
            "variableName": "teamIds"
          }
        ],
        "concreteType": "IntegrationTomra",
        "kind": "LinkedField",
        "name": "setTomraTeamIds",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "teamIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationTomraScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationTomraScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1aecaa57a79dbf8e03602ff371b427ed",
    "id": null,
    "metadata": {},
    "name": "IntegrationTomraScreenMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationTomraScreenMutation(\n  $teamIds: [ID!]!\n) {\n  store {\n    setTomraTeamIds(teamIds: $teamIds) {\n      id\n      teamIds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "55286026d38c2a43096c4aa9cd4cc35e";

export default node;
